import React, { useState } from 'react';
import { Grid, Box, Typography, Card, CardContent, CardActions, IconButton, Table, TableBody, TableCell, TableContainer, TableRow, TableHead, Paper, } from '@mui/material';
import Modal from 'react-bootstrap/Modal';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import ApiService from "../../functions/apiService";
import { Col, Row } from 'react-bootstrap';

const GridView = ({ data, refresh }) => {
    const [deletModal, setDeleteModal] = useState(false)
    const [selectedRecord, setSelectedRecord] = useState(null);

    const handleDeleteClick = (record) => {
        setSelectedRecord(record);
        setDeleteModal(true);
    };

    const handleDelete = async () => {
        if (!selectedRecord) return;
        try {
            const response = await ApiService.post('/payroll/delete-payrollRecord', {
                Shift_Number: selectedRecord.shift_number,
                Shift_Date: selectedRecord.shift_date
            });
            toast.success(response.message)
            refresh()
            setDeleteModal(false);
        } catch (error) {
            toast.error(error.message)
        }
    };
    return (
        <>
            <Grid container spacing={4}>
                {data.map((row, index) => (
                    <Grid item xs={12} key={index}>
                        <Card sx={{ border: "1px solid #CCCCCC", borderRadius: "12px", backgroundColor: "#f5f5f566" }}>
                            <CardContent sx={{ paddingBottom: "16px" }}>
                                <div className='d-flex justify-content-between' style={{ paddingBottom: "12px", borderBottom: "1px solid #cccccc", }}>
                                    <Typography color="#000000" fontFamily="karla">
                                        {row.shift_date}
                                    </Typography>
                                    <img src='/images/delete.svg' style={{ cursor: 'pointer' }} onClick={() => handleDeleteClick(row)} />
                                </div>
                                <Typography variant="h6" fontWeight="bold" sx={{ mt: 1 }} fontSize="18px" fontFamily="karla">
                                    {row.employee_name}
                                </Typography>
                                <TableContainer component={Paper} sx={{ backgroundColor: "transparent", border: "0", boxShadow: "0" }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ border: "0", padding: "8px 8px 0px 0px" }}><Typography color="#808080" fontSize="14px" fontFamily="karla">Date</Typography></TableCell>
                                                <TableCell style={{ border: "0", padding: "8px 8px 0px 8px" }}><Typography color="#808080" fontSize="14px">Run No.</Typography></TableCell>
                                                <TableCell style={{ border: "0", padding: "8px 8px 0px 8px" }}><Typography color="#808080" fontSize="14px">Reason</Typography></TableCell>
                                                <TableCell style={{ border: "0", padding: "8px 8px 0px 8px" }}><Typography color="#808080" fontSize="14px">Start</Typography></TableCell>
                                                <TableCell style={{ border: "0", padding: "8px 8px 0px 8px" }}><Typography color="#808080" fontSize="14px">End</Typography></TableCell>
                                                <TableCell style={{ border: "0", padding: "8px 8px 0px 8px" }}><Typography color="#808080" fontSize="14px">Hours</Typography></TableCell>
                                                <TableCell style={{ border: "0", padding: "8px 8px 0px 8px" }}><Typography color="#808080" fontSize="14px">Pay Code</Typography></TableCell>
                                                <TableCell style={{ border: "0", padding: "8px 8px 0px 8px" }}><Typography color="#808080" fontSize="14px">Created By</Typography></TableCell>
                                                <TableCell style={{ border: "0", padding: "8px 8px 0px 8px" }}><Typography color="#808080" fontSize="14px">Timestamp</Typography></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell style={{ border: "0", padding: "8px 8px 0px 0px" }}><Typography color="#000000" fontSize="16px" fontFamily="karla">{row.shift_date}</Typography></TableCell>
                                                <TableCell style={{ border: "0", padding: "8px 8px 0px 8px" }}><Typography color="#000000" fontSize="16px" fontFamily="karla">{row.assignment_code} </Typography></TableCell>
                                                <TableCell style={{ border: "0", padding: "8px 8px 0px 8px" }}><Typography color="#000000" fontSize="16px" fontFamily="karla">{row.detail_text}</Typography></TableCell>
                                                <TableCell style={{ border: "0", padding: "8px 8px 0px 8px" }}><Typography color="#000000" fontSize="16px" fontFamily="karla">{row.start_time}</Typography></TableCell>
                                                <TableCell style={{ border: "0", padding: "8px 8px 0px 8px" }}><Typography color="#000000" fontSize="16px" fontFamily="karla">{row.end_time}</Typography></TableCell>
                                                <TableCell style={{ border: "0", padding: "8px 8px 0px 8px" }}><Typography color="#000000" fontSize="16px" fontFamily="karla">{row.hours}</Typography></TableCell>
                                                <TableCell style={{ border: "0", padding: "8px 8px 0px 8px" }}><Typography color="#000000" fontSize="16px" fontFamily="karla">{row.pay_code}</Typography></TableCell>
                                                <TableCell style={{ border: "0", padding: "8px 8px 0px 8px" }}><Typography color="#000000" fontSize="16px" fontFamily="karla">{row.created_by}</Typography></TableCell>
                                                <TableCell style={{ border: "0", padding: "8px 8px 0px 8px" }}><Typography color="#000000" fontSize="16px" fontFamily="karla">{row.create_time}</Typography></TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            <Modal show={deletModal} onHide={() => setDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Record</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ color: '#555555' }}>
                        Are you sure to delete this Record?
                    </div>
                    <Row>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setDeleteModal(false)}>
                                Cancel
                            </ButtonTheme>
                        </Col>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={handleDelete}>
                                Delete
                            </ButtonTheme>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default GridView;
